import type {
    IncomeSplitExecution,
    IncomeSplitOverviewData,
    IncomeSplitOverviewHistory,
} from '@fruitful/income-split';
import { atom } from 'jotai';

export const incomeSplitOverviewDataAtom = atom<IncomeSplitOverviewData | null>(
    null,
);

export const selectedIncomeSplitMonthAtom =
    atom<IncomeSplitOverviewHistory | null>(null);

export const selectedIncomeSplitExecutionAtom =
    atom<IncomeSplitExecution | null>(null);

export const selectedIncomeSplitExecutionIndexAtom = atom<number | null>(null);
